export default "__VITE_ASSET__Z5bJAdJJ__"